<template>
  <div>{{ version }}</div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'version',
  created () {
    this.$store.dispatch('setLoader', false)
  },
  data () {
    return {
      version: process.env.VUE_APP_GIT_REVISION
    }
  },
  methods: {
    ...mapActions(['setLoader'])
  }
}
</script>

<style lang="scss">
</style>
